import React from 'react';
import PropTypes from 'prop-types';
import styles from './AccountSignupFormV2.scss';
import Microfrontend from '../../../Microfrontend';

const AccountSignupFormV2 = ({
  authorizationUrls,
  flashMessage,
  config
}) => {
  const { hostname } = window.location;
  const isLocal = hostname === 'localhost' || hostname === '127.0.0.1';

  return (
    <div className={styles.container}>
      {isLocal ? (
        <Microfrontend
          url="http://localhost:8082/remoteEntry.js"
          scope="strava_loh_registration_panel_wrapper"
          component="./LohRegistrationPanelWrapper"
          appContext={{ authorizationUrls, flashMessage, config }}
        />
      ) : <span>packaged-ui</span>}
    </div>
  );
};

AccountSignupFormV2.defaultProps = {
  flashMessage: null
};

AccountSignupFormV2.propTypes = {
  flashMessage: PropTypes.string,
  config: PropTypes.shape({
    appleEnabled: PropTypes.bool.isRequired,
    appleState: PropTypes.string.isRequired // https://developer.apple.com/documentation/sign_in_with_apple/clientconfigi/3230956-state
  }).isRequired,
  authorizationUrls: PropTypes.shape({
    google: PropTypes.string.isRequired,
    facebook: PropTypes.string.isRequired
  }).isRequired
};

export default AccountSignupFormV2;
